// Needs to be in order as we want to display in invoice pdf
export enum UserInfoNeeded {
  COMPANY_NAME = 'companyName', // First
  COMPANY_ADDRESS = 'companyAddress', // Second
  FULL_NAME = 'fullName', // Third
  EMAIL = 'email', // Fourth
  PHONE_NUMBER = 'phoneNumber', // Fifth
}
